import { Filter } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useProviderFilter } from "@/hooks/useProviderFilter";

export default function PatientFilterBar() {
  const ctx = useProviderFilter();
  if (!ctx) return null;
  const { providers, filter, setFilter, currentUserId } = ctx;

  return (
    <div className="bg-card border border-border rounded-xl p-2.5 mb-3 flex items-center gap-2" data-testid="patient-filter-bar">
      <Filter className="w-3.5 h-3.5 text-muted-foreground shrink-0 ml-1" />
      <Select value={filter} onValueChange={setFilter}>
        <SelectTrigger className="h-8 text-xs border-0 shadow-none focus:ring-0" data-testid="patient-filter-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" data-testid="filter-all">All patients</SelectItem>
          <SelectItem value="me" data-testid="filter-me">My patients</SelectItem>
          {providers.filter(p => p.id !== currentUserId).map(p => (
            <SelectItem key={p.id} value={p.id} data-testid={`filter-provider-${p.id}`}>
              {p.full_name}'s patients
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
